import { render, staticRenderFns } from "./TovRow.vue?vue&type=template&id=0bdccc5a&"
import script from "./TovRow.vue?vue&type=script&lang=js&"
export * from "./TovRow.vue?vue&type=script&lang=js&"
import style0 from "./TovRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
